define((require) => {
    "use strict";

    const EventDispatcher     = require("shared/util/EventDispatcher");
    const Promise             = require("shared/util/Promise");
    const Preconditions       = require("shared/util/Preconditions");

    /**
     * Encapsulates a functionality. The <tt>execute</tt> method returns a deferred object to
     * support async and chainable actions.
     *
     * @class Action
     * @see  #execute
     * @see ActionSequence
     *
     * @author Kim
     */
    return EventDispatcher.extend({

        /**
         * Constructor.
         */
        constructor() {
            // Make sure we have the right scope inside #execute
            this.execute = this.execute.bind(this);
        },

        /**
         * Whether the action is currently executable. Useful if the current logged in principal don't have permission.
         *
         * The default implementation returns <tt>true</tt>.
         *
         * @return {Boolean} Whether the action is currently executable.
         */
        executable() {
            return true;
        },

        /**
         * Starts executing the action.
         *
         * @return {Promise}
         *
         * @see ActionSequence
         */
        execute(...args) {
            Preconditions.checkState(this.executable(), "Not allowed to execute action.");

            const value = this._performExecution(...args);

            return Promise.isPromise(value) ? value : Promise.resolved(value);
        },

        _performExecution() {
            return Promise.resolved();
        }

    });
});



// WEBPACK FOOTER //
// ./src/editor/util/Action.js